// extracted by mini-css-extract-plugin
module.exports = {"s1wq5k0m":"s1wq5k0m"};